import { useContext } from 'react'
import type { I18nContextType } from './I18nProvider'
import { I18nContext } from './i18nContext'

export const useI18n = (): I18nContextType => {
  const context = useContext(I18nContext)
  if (context === undefined) {
    throw new Error('useI18n must be used within an I18nProvider')
  }
  return context
}
